import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

const isIBCInternetCustomer = createSlice({
  name: 'isIBCInternetCustomer',
  initialState: {
    isIBC: 'isIBC',
    togglePopover: false,
  },

  reducers: {
    reportAnalytics: (state, action) => {},
    onCheck: {
      reducer(state, action) {
        if (state.isIBC === action.payload.currentBox) {
          state.isIBC = '';
        } else {
          state.isIBC = action.payload.currentBox;
        }
      },
    },
    openPopover: {
      reducer(state, action) {
        if (state.togglePopover === false) {
          state.togglePopover = true;
        }
      },
    },
    closePopover: {
      reducer(state, action) {
        if (state.togglePopover === true) {
          state.togglePopover = false;
        }
      },
    },
  },
});

export const {onCheck, openPopover, closePopover, reportAnalytics} = isIBCInternetCustomer.actions;

export default isIBCInternetCustomer.reducer;
